import React from 'react';
import { Typography } from '@material-ui/core';

import { StepContainerProps } from './StepContainer.types';
import { useStyles } from './StepContainer.styles';

export const StepContainer = ({ children, title }: StepContainerProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography className={classes.title}>{title}</Typography>
      <div className={classes.content}>{children}</div>
    </div>
  );
};
